import { useQuery } from '@tanstack/react-query';

import { getAttractionPerformanceSummary } from '~/services/AttractionsService';

import type { AttractionPerformanceParams } from '~/types/attractionTypes';

import { attractionQueryKeys } from './attractionQueryKeys';

interface UseGetAttractionPerformanceSummaryOptions {
  enabled?: boolean;
}

export function useGetAttractionPerformanceSummary(
  params: AttractionPerformanceParams = {},
  options: UseGetAttractionPerformanceSummaryOptions = {},
) {
  const { enabled = true } = options;
  return useQuery({
    queryKey: attractionQueryKeys.performanceSummary(params as Record<string, unknown>),
    queryFn: async ({ signal }) => {
      return await getAttractionPerformanceSummary(params, { signal });
    },
    enabled,
    retry: false,
  });
}
